import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import "@/mixins/hamochi";
import "@/mixins/locale";
import "@/mixins/route";
import "@/mixins/string";
import _ from "lodash";
import moment from "moment";
import "./styles/main.scss";
import "./styles/introjs.css";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

//BOC
import { version } from "./../package.json";
Vue.prototype.$version = version;
//EOC
//BOC:[api]
import axios from "axios";
Vue.prototype.$axios = axios;
var api = {
  servers: {
    analysis: process.env.VUE_APP_URL_API_ANALYSIS,
    game: process.env.VUE_APP_URL_API_GAME,
    event: process.env.VUE_APP_URL_API_EVENT,
    log: process.env.VUE_APP_URL_API_LOG,
    question: process.env.VUE_APP_URL_API_QUESTION,
    sso: process.env.VUE_APP_URL_API_SSO,
  },
  fetch: async (props) => {
    var params = {};
    var headers = {};
    var method = "post";
    if (typeof props.params != "undefined") params = props.params;
    if (typeof props.method != "undefined") method = props.method;
    if (typeof props.headers != "undefined") headers = props.headers;
    //BOC:[auto insert token]
    if (typeof store.state.auth.data.Session != "undefined")
      headers.Authorization = "Bearer " + store.state.auth.data.Session.token;
    //EOC
    props.callbackReset();
    try {
      await axios({
        method: method,
        headers: headers,
        url: props.url,
        data: params,
      }).then(
        (response) => {
          if (response.data == null) {
            props.callbackError("Item not found.");
          } else if (response.data.error) {
            props.callbackError(response.data.error);
          } else {
            props.callbackSuccess(response.data);
          }
        },
        (error) => {
          if (
            typeof error.response != "undefined" &&
            typeof error.response.data != "undefined"
          ) {
            var err;
            if (
              typeof error.response.data.errors != "undefined" &&
              error.response.data.errors
            ) {
              //read Laravel ValidationException errors message
              var errors = error.response.data.errors;
              err = errors[Object.keys(errors)[0]];
            } else if (typeof error.response.data.message != "undefined") {
              err = error.response.data.message;
              if (err == "Authorization token expired") {
                //BOC:[locale]
                var locale = window.location.pathname.replace(
                  /^\/([^/]+).*/i,
                  "$1"
                );
                if (locale == "/") locale = "en";
                //EOC
                window.location.replace("/" + locale + "/error/expired");
              }
            } else {
              err = error;
            }
            props.callbackError(err);
          } else {
            props.callbackError(error);
          }
        }
      );
    } catch (e) {
      props.callbackError(e);
    }
  },
};
Vue.prototype.$api = api;
//EOC
//BOC
Vue.prototype.$_ = _;
//EOC
//BOC
Vue.prototype.$moment = moment;
//EOC
//BOC:[components]

Vue.prototype.$connectionSpeed = 200;

var bgMusic = new Audio();

bgMusic.loop = true

window.addEventListener("load", function () {
  bgMusic.play();
});
window.addEventListener("focus", function () {
  bgMusic.play();
});
window.addEventListener("blur", function () {
  bgMusic.pause();
});

Vue.prototype.$bgMusic = bgMusic;

Vue.component("Empty", require("@/components/Empty.vue").default);
Vue.component("Loader", require("@/components/Loader.vue").default);

// new abstract avatar
Vue.component("Avatar", () =>
  import(
    /* webpackChunkName: "component-abstract-avatar" */ "@/components/avatar/AbstractAvatar.vue"
  )
);

// buttons
Vue.component("EnterBtn", () =>
  import(
    /* webpackChunkName: "component-entr-btn" */ "@/components/btns/EnterBtn.vue"
  )
);

//EOC
//BOC:[meta]
import VueMeta from "vue-meta";
Vue.use(VueMeta);
Vue.use(LottieVuePlayer);
//EOC

import VueIntro from "vue-introjs";
Vue.use(VueIntro);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
